<template>
  <div class="home">
    <div class="md-example-child md-example-child-swiper md-example-child-swiper-0">
      <md-swiper
        ref="swiper"
        :is-prevent="false"
        :useNative-driver="false"
        :transition-duration="1000"
        :autoplay="4000"
      >
        <md-swiper-item :key="$index" v-for="(item, $index) in swiperList">
          <img class="banner-item" :src="`/manager/fileserver/file/download?id=${item.logoUrl}`" @click="gotoDetail(item)">
        </md-swiper-item>
      </md-swiper>
    </div>
    <div class="menuBar">
        <div class="menuItem" @click="goto(1)">
            <i class="iconfont menuSe1">&#xe612;</i>
            <span>会员资料</span>
        </div>
        <div class="menuItem" @click="goto(2)">
            <i class="iconfont menuSe2">&#xe681;</i>
            <span>积分换券</span>
        </div>
        <div class="menuItem" @click="goto(3)">
            <i class="iconfont menuSe4">&#xe63c;</i>
            <span>积分换礼</span>
        </div>
        <div class="menuItem" @click="goto(4)">
            <i class="iconfont menuSe7">&#xe7ef;</i>
            <span>智能停车</span>
        </div>
        <div class="menuItem" @click="goto(5)">
            <i class="iconfont menuSe3">&#xe61f;</i>
            <span>兑换记录</span>
        </div>
        <div class="menuItem" @click="goto(6)">
            <i class="iconfont menuSe8">&#xe62c;</i>
            <span>我要签到</span>
        </div>
        <div class="menuItem" @click="goto(7)">
            <i class="iconfont menuSe5">&#xe607;</i>
            <span>会员规则</span>
        </div>
        <div class="menuItem" @click="goto(8)">
             <i class="iconfont menuSe6">&#xe616;</i>
            <span>服务中心</span>
        </div>
        <div class="menuItem" @click="goto(9)">
             <i class="iconfont " style='color:#3EBFC1;'>&#xe65a;</i>
            <span>拍照积分</span>
        </div>
    </div>

    <div class="stopShow" style="background-color:white;" v-if="themsList.length != 0">
      <div class="stopHead">
        <div class="stopHeadTitle"><i class="iconfont">&#xe609;</i> <span class="titleGoods">{{themeNa}}</span></div><span></span>
      </div>
      <!-- <div class="stopShowChild"> -->
        <div class="stopShowChild">
        <div class="shopImgBox" v-for="(item, $index) in hotList" :key="$index" @click="gotoThemes(item)">
          <img :src="'/manager/fileserver/file/download?id='+item.themeImg" />
        </div>
      </div>

        <!-- <div class="md-example-child md-example-child-swiper md-example-child-swiper-0" style="height: 120px;padding: 5px;">
          <md-swiper
            ref="swiper"
            :is-prevent="false"
            :useNative-driver="false"
            :transition-duration="1000"
            :autoplay="4000"
          >
            <md-swiper-item :key="$index" v-for="(item, $index) in hotList"  >
              <img class="banner-item" :src="`/manager/fileserver/file/download?id=${item.themeImg}`" @click="gotoThemes(item)">
            </md-swiper-item>
            
          </md-swiper>
      </div> -->
    </div>

    <!-- <div class="stopShow" >
      <div class="stopHead">
        <div class="stopHeadTitle"><i class="iconfont">&#xe63e;</i> <span class="titleGoods">热门品牌</span></div><span>MORE ></span>
      </div>
      <div class="stopShowChild">
        <div class="shopImgBox" v-for="(item, $index) in stopList" :key="$index" @click="gotoShopDetail(item)">
          <img :src="'/manager/fileserver/file/download?id='+item.logoUrl" />
      </div>
      </div>
    </div> -->

  </div>
</template>
<script>
export default {
  data() {
    return {
      themeNa:'',
      stopList:[],
      swiperList:[],
      hotList:[],
      themsList:[]
    };
  },
  mounted() {
      document.title="首页"

      this.$http.get('/sangto-wrm/WxAdverShow/checkAll').then(({data})=>{//轮播图信息
          this.swiperList = data.data.rows
      })

      this.$http.post('/sangto-wrm//WxExtendBrand/page').then(({data})=>{ //品牌列表数据

          this.stopList = data.data.rows
      })

      //热门主题
      this.$http.get('/sangto-wrm/WxHotTheme/checkAll').then(({data})=>{//轮播图信息
          this.themsList = data.data.rows;
          if(data.data.rows.length > 0){
            this.themeNa = data.data.rows[0].themeNa
            this.hotList = [
              {
                themeImg:data.data.rows[0].themeImg1,
                themeUrl:data.data.rows[0].themeUrl1,
              }
            ]
            if(data.data.rows[0].themeImg2){
              this.hotList.push({
                themeImg:data.data.rows[0].themeImg2,
                themeUrl:data.data.rows[0].themeUrl2,
              })
            }
            if(data.data.rows[0].themeImg3){
              this.hotList.push({
                themeImg:data.data.rows[0].themeImg3,
                themeUrl:data.data.rows[0].themeUrl3,
              })
            }
            if(data.data.rows[0].themeImg4){
              this.hotList.push({
                themeImg:data.data.rows[0].themeImg4,
                themeUrl:data.data.rows[0].themeUrl4,
              })
            }
          }
      })
  },
  methods: {
    goto(id){
        switch (id) {
            case 1:
                //会员资料
                this.$router.push('/appMain/memberDatum')
                break
            case 2:
                //积分换券
                this.$router.push('/appMain/integralTicket')
                break
            case 3:
                //积分换礼
                this.$router.push('/appMain/integralGift')
                break
            case 4:
                //智能停车
                this.$router.push('/stopCar')
                break
            case 5:
                //兑换详情
                this.$router.push('/appMain/exchangeDetails')
                break
            case 6:
                //我要签到
                this.$router.push('/appMain/signIn')
                break
            case 7:
                //会员规则
                this.$router.push('/appMain/memberRuleList')
                break
            case 8:
                //服务中心
                this.$router.push('/appMain/serviceContentList')
                break
            case 9:
                //拍照积分
                this.$router.push('/appMain/takingPicturesIntegral')
                break
        }
    },
      gotoDetail(item){ //调整轮播详情
            window.location.href = item.imgUrl
            // this.$router.push({path:'/shopDetails',query:{itemData: JSON.stringify(item)}})
      },
      gotoShopDetail(item){ //商品展示详情
          this.$router.push({path:'/shopGiftDetails',query:{itemData: JSON.stringify(item)}})
      },
      gotoThemes(item){ //热门主题链接跳转
        window.location.href = item.themeUrl
      }
  }
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  .md-example-child-swiper-0{
    height: 180px;
  }
  .banner-item{
        width :100%;
        height: 100%;
    }
   .menuBar{
       width: 100%;
       height: 240px;
       display: flex;
       flex-wrap: wrap;
       align-content: flex-start;
       background: #fff;
   }
   .menuItem{
       width: 33%;
       height: 33%;
       display: flex;
       flex-direction: column;
       justify-content: center;
       align-items: center;
       span{
         margin-top: 4px;
         font-size: 14px;
         color: #555;
       }
   }
   i{
      font-size: 24px;
    }
    .titleGoods{
        font-weight: 600;
    }
   .menuSe1{
     color: #3ebfc1;
   } 
   .menuSe2{
     color: #fe4f51;
   } 
   .menuSe3{
     margin-top: 2px;
     font-size: 22px;
     color: #6a91ef;
   } 
   .menuSe4{
     color: #4acdfe;
   } 
   .menuSe5{
     color: #f9286d;
   } 
   .menuSe6{
     color: #ff7654;
   } 
   .menuSe7{
     color: #28da83;
   } 
   .menuSe8{
     color: #ac71e0;
   }
   .stopShow{
     
     margin-top: 10px;
     width: 100%;
   }
   .stopShowChild{
     position: relative;
       width: 100%;
       display: flex;
        flex-direction: column;
       align-items: center;
       padding-bottom: 20px;
       background-color: #fff;
   }
   .stopHead{
     width: 100%;
     height: 50px;
      background: #fff;
      border-bottom: 1px solid #f1f1f1;
      display: flex;
     justify-content: space-between;
     align-items: center;
     box-sizing: border-box;
     padding: 0 10px;
     span{
       font-size: 14px;
       color: #555;
     }
   }
   .stopHeadTitle{
       font-size: 14px;
       i{
         position: relative;
         top: 1px;
         font-size: 14px;
         color: #444;
       }
      span{
        color: #f37474;
        margin-left: 2px;
      }
   }
   .shopImgBox{
        width: 96%;
       margin-top: 10px;
       border-radius: 8px;
        height: 120px;
       display: flex;
       justify-content: center;
       background-color: #fff;
       box-shadow: 1px 1px 4px 0 rgba(0,0,0,0.3);
       overflow: hidden;
       img{
           width: 100%;
           height: 100%;
       }
   } 
}
</style>
